const getSizeList = (sizes) => {
    let optionsList = '';
    let sizesKeys = Object.keys(sizes);

    sizesKeys.forEach(sizeKey => {
        if (sizes[sizeKey] > 0){
            optionsList += `<option value="${sizeKey}">${sizeKey}</div>`;
        }
    })
    return optionsList
}

const closeModal = () =>{
    $('.pent-modal').removeClass('open');
    $('.modal-content').remove();
}

const openProductModal = (productId) => {
    $('.pent-modal').addClass('open');
    let id = productId;
    let product = products[productId];
    let modalContent = `
        <div class="modal-content">
            <img
                class="modal-close-button"
                src="/assets/images/ui/close-button.png"
                onClick="closeModal()"
                >
            <h4 class="modal-title">${product.title}</h4>
            <div class="modal-content-in pt-4 pl-2 pr-2">
                <img style="width: 100%" src="${product.img}"/>
            </div>
            <div class="modal-size-select pl-2 pr-2">
                <div class="form-group">
                    <label for="pent-size pb-2">Seleziona Misura</label>
                    <select class="form-control" id="pent-size">
                        ${getSizeList(product.sizes)}
                    </select>
                </div>
            </div>
            <div class="addToCartButton pl-2 pr-2 pb-2">
                <button class="w-100" onClick="addProductToCart('${id}')"><small>+ Aggiungi al carrello</small></button>
            </div>
        </div>
    `
    $('.pent-modal').append(modalContent);
}

const openLoginModal = checkout => {
    $('.pent-modal').addClass('open');
    let modalContent = `
        <div class="modal-content">
            <img
                class="modal-close-button"
                src="/assets/images/ui/close-button.png"
                onClick="closeModal()"
                >
            <h4 class="modal-title">Login</h4>
            <div class="spacer" style="height: 70px"></div>
            <div class="modal-content-in pt-4 pl-2 pr-2">
                <div class="form-group">
                    <label for="pent-size pb-2">email</label>
                    <input type="text" id="loginEmail" class="form-control">
                    </input>
                </div>
                <div class="password">
                    <label for="pent-size pb-2">password</label>
                    <input type="password" id="loginPassword" class="form-control">
                    </input>
                </div>
            </div>
            <div class="login-button-group">
                <div onclick="login(${checkout})" class="loginButton pl-2 pr-2 pb-2">
                    <button class="w-100"><small>Login</small></button>
                </div>
                <p><small>Se non sei registrato <span class="clickable" onclick="turnToSignUpForm(${checkout})"><strong>clicca qui</strong></span></small></p>
            </div>
        </div>
    `
    $('.pent-modal').html(modalContent);
}

const turnToSignUpForm = checkout => {
    $('.pent-modal').addClass('open');
    $('.pent-modal').html(
        `
        <div class="modal-content">
            <img
                class="modal-close-button"
                src="/assets/images/ui/close-button.png"
                onClick="closeModal()"
                >
            <h4 class="modal-title">Registrazione</h4>
            <div class="spacer" style="height: 70px"></div>
            <div class="modal-content-in pt-4 pl-2 pr-2">
                <div class="form-group">
                    <label for="name pb-2">Nome</label>
                    <input required type="text" id="name" class="form-control">
                    </input>
                </div>
                <div class="form-group">
                    <label for="name pb-2">Cognome</label>
                    <input required type="text" id="surname" class="form-control">
                    </input>
                </div>
                <div class="form-group">
                    <label for="pent-size pb-2">email</label>
                    <input required type="text" id="loginEmail" class="form-control">
                    </input>
                </div>
                <div class="password">
                    <label for="pent-size pb-2">password</label>
                    <input required type="password" id="loginPassword" class="form-control">
                    </input>
                </div>
            </div>
            <div class="login-button-group">
                <div onclick="signUp(${checkout})" class="loginButton pl-2 pr-2 pb-2">
                    <button class="w-100"><small>Registrati</small></button>
                </div>
                <p><small>Se sei già registrato <span class="clickable" onclick="openLoginModal(${checkout})"><strong>clicca qui</strong></span></small></p>
            </div>
        </div>
        `
    );
}

/**
 * Restituisce i campi del carrello
 */
const getCartFields = () => {
    let options = country_list.map(country => ({text: country, value: country}));
    options.unshift({text: 'Seleziona uno stato', value: ''});
    const address = userInfo.address || {};

    return [
        {label: 'Nome e Cognome Destinatario', name: 'fullName', value: address.fullName, type: 'text', rules: { required: true }},
        {label: 'Indirizzo', name: 'addressLine', value: address.addressLine, type: 'text', rules: { required: true }},
        {label: 'Indirizzo Linea 2', name: 'addressLineB', value: address.addressLineB, type: 'text', rules: { required: false }},
        {label: 'CAP', name: 'zip', value: address.zip, type: 'text', rules: { required: true }},
        {label: 'Città', name: 'city', value: address.city, type: 'text', rules: { required: true }},
        {label: 'Stato', name: 'state', value: address.country, type: 'select', options: options, rules: { required: true }},
        {label: 'Telefono', name: 'telephone', value: address.telephone, type: 'text', rules: { required: false }}
    ];
}

/**
 * Verifica se il campo filter o se tutti i campi del carrello sono valido
 */
const validateCart = filter => {
    const fields = getCartFields();
    let elements = fields.map(field => $(`#${field.name}`)[0]);
    if(filter) {
        elements = elements.filter(element => element.id === filter);
    }
    let rules = {};
    fields.forEach(field => {rules[field.name] = field.rules});
    const validator = new Validation(rules, elements);
    const errors = validator.validate();
    const keys = Object.keys(errors);
    if(keys.length > 0) {
        keys.forEach(name => {
            let input = validator.getField(name);
            input.classList.add('error');
        });
    }

    return errors;
}

/**
 * Handler del change dei campi del form del carrello
 * @param {Object} field 
 */
const onChange = field => {
    const errors = validateCart(field.name);
    const keys = Object.keys(errors);
    let input = $(`#${field.name}`)[0];
    if(keys.length > 0) {
        removeOrderCheckout();
        input.classList.add('error');
    } else {
        input.classList.remove('error');
    }
}

/**
 * Renderizza il campo passato come argomento
 * @param {Object} field 
 */
const renderField = field => {
    const address = userInfo.address || {};
    let header = `<div class="form-group">`;
    let footer = `</div>`;
    let label  = `<label for="pent-size pb-2">${field.label} ${field.rules.required ? '*' : ''}</label>`;
    let input = '';
    if(field.type === 'select') {
        input = `<div>
                    <select
                        onChange='onStateChange();onChange(${JSON.stringify(field)})'
                        name="${field.name}"
                        id="${field.name}"
                        value="${address.country}"
                    >
                    ${field.options.map(option => (`<option value="${option.value}" ${option.value === field.value ? 'selected' : ''}>${option.text}</option>`)).join('')}
                    </select>
                </div>`;
    } else {
        input = `<input
                    value="${field.value ? field.value : ''}"
                    type="${field.type}"
                    name="${field.name}"
                    id="${field.name}"
                    onChange='onChange(${JSON.stringify(field)})'
                    class="form-control"
                />`;
    }
    return [header, label, input, footer].join('');
}

/**
 * Apre il modale contentente il carrello
 * @param {*} checkout 
 */
const openCheckoutModal = checkout => {
    $('.pent-modal').addClass('open');
    const fields = getCartFields();

    let modalContent = `
        <div class="modal-content">
            <img
                class="modal-close-button"
                src="/assets/images/ui/close-button.png"
                onClick="closeModal()"
                >
            <h4 class="modal-title">Checkout</h4>
            <div class="spacer" style="height: 70px"></div>
            <div class="modal-content-in pt-4 pl-2 pr-2">
                <h4><small>Indirizzo di spedizione</small></h4><br>
                ${fields.map(renderField).join('')}
                <div class="cart">
                    <h4><small>Riepilogo Ordine</small></h4><br>
                    ${getProductListTemp()}
                </div>
            </div>
            <div onClick="onCheckoutSubmit()" class="checkOutButton pl-2 pr-2 pb-2">
                <button class="w-100"><small>Paga Subito</small></button>
            </div>
            <div id="pay-button" class=" pl-2 pr-2 pb-2">
            </div>
        </div>
    `
    $('.pent-modal').append(modalContent);
}

/**
 * Gestisce l'evento di submit del carrello
 * @param {Event} e
 */
const onCheckoutSubmit = e => {
    const errors = validateCart();
    const keys = Object.keys(errors);
    if(keys.length > 0) {
        return removeOrderCheckout();
    }
    return createOrderCheckout();
}

const getProductListTemp = () => {
    let productListTemp = '';
    cart.productList.forEach((product,index) => {
        productListTemp += `
            <div class="row cart-item" id="${product.ui_seq_id}">
                <div class="col-9 text-left">
                    <p><small>${product.name}(Taglia ${product.size})</small></p>
                </div>
                <div class="col-3 text-right">
                    <p><small>${product.price}&euro;</small></p>
                </div>
                <div class="text-center remove-div" onClick="removeProductFromCart('${product.ui_seq_id}')">
                    <div class="remove-text"><strong>Rimuovi Prodotto</strong></div>
                </div>
            </div>
        `
        if (index + 1 !== cart.productList.length){
            productListTemp += '<hr style="margin-top:2px; margin-bottom:2px">'
        } else {
            productListTemp += '<hr style="margin-top:2px; margin-bottom:2px">'
            productListTemp += '<br>'
        }
    })
    productListTemp += `
        <div class="row">
            <div class="col-10 text-right">
                <p><small>Spese di spedizione</small></p>
            </div>
            <div class="col-2 text-right">
                <p><small>${Number(cart.shippingCost).toFixed(2)}&euro;</small></p>
            </div>
        </div>
    `;

    if(hasSale()) {
        productListTemp += `
            <div class="row">
                <div class="col-10 text-right text-green">
                    <p><small>Sconto quantità</small></p>
                    <p class="sale-text">Ogni 3 infradito la spedizione è gratis!</p>
                </div>
                <div class="col-2 text-right" style="color: green">
                    <p><small>-${Number(cart.shippingCost).toFixed(2)}€</small></p>
                </div>
            </div>
        `;
    }

    productListTemp += `
        <hr style="margin-top:2px; margin-bottom:2px">
        <div class="row">
            <div class="col-10 text-right">
                <p><small>Totale(Iva inc.)</small></p>
            </div>
            <div class="col-2 text-right">
                <p><small>${(Number(cart.tot) + Number(getShippingCost())).toFixed(2)}€</small></p>
            </div><br><br><br>
        </div>
    `;
    return productListTemp
}

const openCartModal = () => {
    if (cart.productList.length > 0) {
        $('.pent-modal').addClass('open');
        let modalContent = `
        <div class="modal-content cart">
            <img
                class="modal-close-button"
                src="/assets/images/ui/close-button.png"
                onClick="closeModal()"
                >
            <h4 class="modal-title">Carrello</h4>
            <div class="spacer" style="height: 40px"></div>
            <div class="modal-content-in pt-4 pl-2 pr-2">
                ${getProductListTemp()}
            </div>
            <div onClick="completeOrder()" class="loginButton pl-2 pr-2 pb-2">
                <button class="w-100"><small>Completa Ordine</small></button>
            </div>
        </div>
        `;
        $('.pent-modal').append(modalContent);
    }
}

const completeOrder = () => {
    let user = auth.currentUser;
    if (user){
        closeModal();
        openCheckoutModal();
    } else {
        closeModal();
        openLoginModal(true)
    }
}
